import { getBooleanField, getTextField } from '@lender/utils';
import { object } from 'yup';

export const notaryOptionsSchema = object().shape({
  isBold: getBooleanField({ isRequired: false }),
  isUppercase: getBooleanField({ isRequired: false }),
  fontSize: getTextField({ isRequired: false }),
  horizontalAlignment: getTextField({ isRequired: false }),
  fontColor: getTextField({ isRequired: false }),
  fontFamily: getTextField({ isRequired: false }),
  documentTitle: getTextField({ isRequired: false }),
});

export const NotaryActionName = {
  ACKNOWLEDGMENT: 'formatAsNotaryAcknowledgment',
  JURAT: 'formatAsNotaryJurat',
};

export const NotaryActor = {
  ALL_BORROWERS: 'allBorrowers',
  ALL_BORROWERS_AND_NBES: 'allBorrowersAndNbes',
  BORROWER_1: 'borrower1',
  BORROWER_2: 'borrower2',
  BORROWER_3: 'borrower3',
  BORROWER_4: 'borrower4',
  NBE_1: 'nbe1',
  NBE_2: 'nbe2',
  NBE_3: 'nbe3',
  NBE_4: 'nbe4',
};

export const notaryActorOptions = [
  { name: 'All Borrowers', value: NotaryActor.ALL_BORROWERS },
  { name: 'All Borrowers and all NBEs', value: NotaryActor.ALL_BORROWERS_AND_NBES },
  { name: 'Borrower 1', value: NotaryActor.BORROWER_1 },
  { name: 'Borrower 2', value: NotaryActor.BORROWER_2 },
  { name: 'Borrower 3', value: NotaryActor.BORROWER_3 },
  { name: 'Borrower 4', value: NotaryActor.BORROWER_4 },
  { name: 'NBE 1', value: NotaryActor.NBE_1 },
  { name: 'NBE 2', value: NotaryActor.NBE_2 },
  { name: 'NBE 3', value: NotaryActor.NBE_3 },
  { name: 'NBE 4', value: NotaryActor.NBE_4 },
];
